import { render, staticRenderFns } from "./userFunctionnalities.vue?vue&type=template&id=59571bbb&scoped=true"
import script from "./userFunctionnalities.vue?vue&type=script&lang=js"
export * from "./userFunctionnalities.vue?vue&type=script&lang=js"
import style0 from "./userFunctionnalities.vue?vue&type=style&index=0&id=59571bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59571bbb",
  null
  
)

export default component.exports